export default function accessByStringDot(obj, accessor) {
    // eslint-disable-next-line no-restricted-globals
    return accessor.split('.').reduce((prev, curr) => (prev ? prev[curr] : null), obj || self);
}
